/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerOwnershipHolderDtoSchema = z.object({
  name: z.optional(z.string()),
  role: z.optional(z.string()),
  stakePct: z.optional(z.number()),
  kind: z.optional(z.string()),
  badge: z.string().nullish(),
  url: z.string().nullish(),
  fte: z.optional(z.string()),
});
